import { workspace_v1_WorkspaceConfig } from '@antimatterhq/asl-api-ts-v1';
import { produce } from 'immer';
import { bumpMetadataVersion } from '@/utils/util';
import { CustomPresetsSchemaValues } from '@/zod/schemas/workspaceConfig/CustomPresetsSchemaValues';

const defaultWorkspaceWithCustomPresetsPath =
  (): workspace_v1_WorkspaceConfig => {
    return {
      spec: {
        daslStoragePath: '',
        daslCustomPresetsPath: '',
        systemTablesConfig: {
          catalogName: '',
          schema: '',
        },
      },
    };
  };

export const getCustomPresetPathInitialValues = (
  workspace: workspace_v1_WorkspaceConfig | undefined,
): CustomPresetsSchemaValues => {
  return {
    daslCustomPresetsPath: workspace?.spec?.daslCustomPresetsPath || '',
    daslStoragePath: workspace?.spec?.daslStoragePath || '',
  };
};

export const setCustomPresetPath = (
  config: workspace_v1_WorkspaceConfig | undefined,
  values: CustomPresetsSchemaValues,
): workspace_v1_WorkspaceConfig => {
  const result = produce(
    config || defaultWorkspaceWithCustomPresetsPath(),
    (draft) => {
      draft.spec = {
        ...draft.spec,
        daslCustomPresetsPath: values.daslCustomPresetsPath
          ? values.daslCustomPresetsPath
          : null,
        daslStoragePath: values.daslStoragePath ?? '',
      };

      bumpMetadataVersion(draft);
    },
  );

  return result;
};
